export enum VatIntegrationLink {
    TaxInvoicesTracking = '/home/audit-management'
}
